<template>
  <div class="container">
    <breadcrumb></breadcrumb>
    <div class="option-wrap">
      <Select v-model="search.audit_status" style="width: 150px;margin-right:10px;" @on-change="loadData">
        <Option value="">全部</Option>
        <Option :value="1">已通过</Option>
        <Option :value="2">待处理</Option>
      </Select>
      <all-user ref="allUser" :type="'all'" @usernameChange="usernameChange"></all-user>
    </div>
    <Table :loading="tableLoading" class="spacingTwice" border :columns="columns" :data="dataList"></Table>
    <Page v-show="total > 10" show-total :total="total" :current="current" :page-size="pageSize"
          @on-change="pageChange" @on-page-size-change="pageSizeChange" show-sizer />
    <Modal :mask-closable="false"
           v-model="checkdata"
           title="审核驳回"
           :loading="loading"
           @on-cancel="cancelReason"
           @on-ok="editData('formValidate')">
      <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="120">
        <FormItem label="驳回理由" prop="reason">
          <Input type="textarea" placeholder="请输入驳回理由，限制50字" v-model="formValidate.aduit_con" maxlength="50" />
        </FormItem>
      </Form>
    </Modal>
    <Modal :mask-closable="false"
           v-model="isShowInfo"
           :footer-hide="true"
           title="详情">
      <Form ref="formApkInfo" :model="formApkInfo" :label-width="120">
        <FormItem label="小程序应用名称" prop="name">
          <Input v-model="formApkInfo.name" :disabled="editFlag" placeholder="请输入小程序名称" />
        </FormItem>
        <FormItem label="公司资质" prop="qualification">
          <Input type="textarea" v-model="formApkInfo.qualification" :disabled="editFlag" placeholder="请输入小程序名称" />
        </FormItem>
        <FormItem label="包名" prop="package_name">
          <Input v-model="formApkInfo.package_name" :disabled="editFlag" placeholder="请输入小程序名称" />
        </FormItem>
        <FormItem label="开发者用户名" prop="username">
          <Input v-model="formApkInfo.username" :disabled="editFlag" placeholder="请输入小程序名称" />
        </FormItem>
        <FormItem label="icon" prop="icon">
          <div><img :src="formApkInfo.icon" style="border-radius:10px;margin-top:10px;" width="100" height="100"></div>
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>

<script>
import breadcrumb from '@/components/global/breadcrumb'
import allUser from '@/components/global/allUser'
import https from '../../https'
import utils from '../../utils'
export default {
  name: 'checkApp',
  data () {
    return {
      loading: true,
      tableLoading: true,
      checkdata: false,
      authorized: false,
      isShowInfo: false,
      selectItems: [],
      sdkVersion: [],
      check: [
        { name: '待审核', val: 1 },
        { name: '审核通过', val: 2 },
        { name: '审核驳回', val: 3 }
      ],
      search: {
        audit_status: ''
      },
      formApkInfo: {},
      formValidate: {
        audit_status: '',
        aduit_con: '',
        package_name: ''
      },
      searchName: '',
      editFlag: true,
      ruleValidate: {
        aduit_con: [
          { required: true, message: '请输入应用名称', trigger: 'blur' },
          { type: 'string', max: 50, message: '最多输入50个字', trigger: 'blur' }
        ]
      },
      dataSource: [], // table数据源
      columns: [ // table表格
        {
          title: '用户名',
          key: 'userName',
          width: 200,
          align: 'center'
        },
        {
          title: 'icon',
          key: 'icon',
          align: 'center',
          width: 90,
          render: (h, params) => {
            return h('img', {attrs: {
              src: params.row.icon
            },
            style: {
              width: '50px',
              height: '50px',
              marginTop: '10px'
            }
            })
          }
        },
        {
          title: '小程序应用名称',
          key: 'name',
          minWidth: 200
        },
        {
          title: '审核状态',
          key: 'audit_status',
          width: 150,
          align: 'center',
          render: (h, params) => {
            let checked = ''
            this.check.forEach(n => {
              if (n.val === params.row.audit_status) checked = n.name
            })
            let html = [
              h('span', checked)
            ]
            if (params.row.audit_status === 3 && params.row.aduit_con) {
              html.push(h('Tooltip', {
                props: {
                  placement: 'bottom',
                  content: params.row.aduit_con
                }
              }, [
                h('Icon', {
                  props: {
                    type: 'ios-help-circle-outline'
                  },
                  style: {
                    color: '#f00'
                  }
                })
              ]))
            }
            return h('div', html)
          }
        },
        {
          title: '包名',
          key: 'package_name',
          align: 'center',
          minWidth: 200
        },
        {
          title: '操作人',
          key: 'update_by',
          align: 'center',
          width: 200
        },
        {
          title: '创建时间',
          key: 'created_at',
          align: 'center',
          width: 200
        },
        {
          title: '更新时间',
          key: 'updated_at',
          align: 'center',
          width: 200
        },
        {
          title: '操作',
          width: 230,
          align: 'center',
          fixed: 'right',
          render: (h, params) => {
            return h('div', [
              h('Button', {
                props: {
                  type: 'success',
                  size: 'small'
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.isShowInfo = true
                    this.formApkInfo = params.row
                  }
                }
              }, '详情'),
              h('Button', {
                props: {
                  type: 'success',
                  size: 'small',
                  disabled: params.row.audit_status === 2 || params.row.audit_status === 3
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.formValidate.audit_status = 2
                    this.formValidate.package_name = params.row.package_name
                    this.editData('formValidate')
                  }
                }
              }, '通过'),
              h('Button', {
                props: {
                  type: 'error',
                  size: 'small',
                  disabled: params.row.audit_status === 2 || params.row.audit_status === 3
                },
                on: {
                  click: () => {
                    this.checkdata = true
                    this.formValidate.audit_status = 3
                    this.formValidate.package_name = params.row.package_name
                  }
                }
              }, '拒绝')
            ])
          }
        }
      ],
      tvpList: [],
      dataList: [], // tab当前页数据
      total: 0, // tab总条数
      pageSize: 10, // 每页多少条
      current: 1 // 当前页
    }
  },
  components: {
    breadcrumb,
    allUser
  },
  created () {
    if (!https.token) {
      this.$router.push('/')
      return
    }
    this.loadData()
  },
  methods: {
    formatDay: utils.formatDay,
    usernameChange (val) {
      this.searchName = val
      this.loadData()
    },
    // 加载tabs列表
    loadData () {
      https.request({
        method: 'get',
        // url: '/v1/check/app',
        url: '/v2/es/audit/apps',
        // aduit_stats=9&uid=&page=2
        params: {
          status: this.search.audit_status,
          page_size: this.pageSize,
          page: this.current,
          uid: this.searchName
        }
      }).then(res => {
        this.tableLoading = false
        // this.dataSource = res.data || []
        this.getUserNameFun(res.data.items || [])
        // this.getUserUpFun(res.data || [])
        this.total = res.data.total
        // this.setData()
      }).catch(error => {
        this.$Message.error(error)
      })
    },
    getUserNameFun (list) {
      let arr = []
      list.map(item => {
        arr.push(item.uid)
      })
      let str = arr.join(',')
      console.log(str)
      https.request({
        method: 'get',
        url: `getUsernamesByIds?ids=${str}`,
        params: {}
      }).then(res => {
        res.data.map(item => {
          list.map(sItem => {
            if (item.value === sItem.uid) {
              sItem['userName'] = item.text
            }
          })
        })
        this.dataList = list
      })
    },
    // getUserUpFun (list) {
    //   let arr = []
    //   list.map(item => {
    //     arr.push(item.update_by)
    //   })
    //   let str = arr.join(',')
    //   console.log(str)
    //   https.request({
    //     method: 'get',
    //     url: `getUsernamesByIds?ids=${str}`,
    //     params: {}
    //   }).then(res => {
    //     res.data.map(item => {
    //       list.map(sItem => {
    //         if (Number(item.value) === sItem.update_by) {
    //           sItem['update_by'] = item.text
    //         }
    //       })
    //     })
    //     this.dataList = list
    //     this.dataSource = list
    //   })
    // },
    // 数据静态分页
    setData () {
      this.dataList = []
      this.total = this.dataSource.length
      for (let i = (this.current - 1) * this.pageSize; i < this.current * this.pageSize; i++) {
        if (i === this.total) return false
        this.dataList.push(this.dataSource[i])
      }
    },
    // 表格排序
    sortChange (data) {
      if (data.order !== 'normal') {
        this.sort = [data.key, data.order].join(' ')
        this.loadData()
      }
    },
    // 页数切换
    pageChange (page) {
      this.current = page
      this.loadData()
    },
    // 每页条数控制
    pageSizeChange (size) {
      this.pageSize = size
      this.current = 1
      this.loadData()
    },
    cancelReason () {
      this.formValidate.aduit_con = ''
    },
    editData (form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          setTimeout(() => {
            this.changeLoading()
            let params = {
              status: this.formValidate.audit_status,
              pkg_name: this.formValidate.package_name
            }
            if (this.formValidate.audit_status === 3) {
              params.aduit_con = this.formValidate.aduit_con
            }
            https.request({
              method: 'put',
              url: '/v2/es/audit/app',
              data: params
            }).then(res => {
              if (res.code === 400) {
                this.$Message.success(res.message)
                this.checkdata = false
                this.loadData()
                return
              }
              this.$Message.success('提交成功')
              this.$refs['formValidate'].resetFields()
              this.formValidate = {
                audit_status: '',
                aduit_con: '',
                package_name: ''
              }
              this.checkdata = false
              this.loadData()
            }).catch(error => {
              this.$Message.error(error)
            })
          }, 1000)
        } else {
          this.changeLoading()
        }
      })
    },
    changeLoading () {
      this.loading = false
      this.$nextTick(() => {
        this.loading = true
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .file-wrap {
    position: relative;
    display: inline-block;
    .file-input {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 1;
      width: 100%;
      height: 100%;
      opacity: 0;
    }
  }
  .option-wrap{
    display: flex;
  }
</style>



// WEBPACK FOOTER //
// src/components/check/checkApp.vue